export default {
  phoneNumber: 'Mobile Number',
  emailAddress: 'Email Address',
  empty: 'Not provided',
  edit: 'Edit',
  add: 'Add',
}
